import { plantInfo } from './../models/plant';
import { GatewayInfo } from 'models/gateway';
import { ViewerForm, ViewerInfo } from 'models/viewers';
import { ListParams, ListResponse } from './../models/common';
import axiosClient from './axiosClient';

const urlApi = '/api/v1/viewer';
export const viewersApi = {
  fetchViewers(param: ListParams): Promise<ListResponse<ViewerInfo>> {
    let url;
    if (param.search_label) {
      url = `${urlApi}-list?page_size=${param._limit}&page=${param._page}&text_search=${param.search_label}`;
    } else {
      url = `${urlApi}-list?page_size=${param._limit}&page=${param._page}`;
    }
    return axiosClient.get(url);
  },
  add(data: ViewerForm): Promise<ViewerInfo> {
    const url = `${urlApi}`;
    return axiosClient.post(url, data);
  },
  update(data: Partial<GatewayInfo>): Promise<GatewayInfo> {
    const url = `${urlApi}/${data.id}`;
    return axiosClient.put(url, data);
  },
  remove(id: string): Promise<any> {
    const url = `${urlApi}/?viewer_id=${id}`;
    return axiosClient.delete(url);
  },
  removePlantToViewer(param: ListParams): Promise<any> {
    const url = `${urlApi}/plant`;
    return axiosClient.delete(url, {
      data: {
        viewer_id: param.viewer_id,
        plant_id: param.plant_id,
      },
    });
  },
  activate(param: ListParams): Promise<string> {
    const url = `${urlApi}/activate?viewer_id=${param.id}&password=${param.password} `;
    return axiosClient.post(url);
  },
  fetchViewerInfo(param: ListParams): Promise<GatewayInfo> {
    const url = `${urlApi}/${param.type}/${param.id}`;
    return axiosClient.get(url);
  },
  fetchViewerEnabled(param: ListParams): Promise<string> {
    const url = `${urlApi}/enabled?viewer_id=${param.id}&user_credentials_enabled=${param.type}`;
    return axiosClient.put(url, {});
  },
  getPlantsByViewerId(id: string): Promise<plantInfo[]> {
    const url = `${urlApi}/plant-list?viewer_id=${id}`;
    return axiosClient.get(url);
  },
  addPlantToViewer(param: ListParams): Promise<string> {
    const url = `${urlApi}/plant`;
    return axiosClient.post(url, {
      viewer_id: param.viewer_id,
      plant_id: param.plant_id,
    });
  },
};
